import DigesterHeader from "@/features/feedstock/components/DigesterHeader"
import DigesterMetricsTable from "@/features/feedstock/components/DigesterMetricsTable"

export default function DigesterMetrics() {
  return (
    <>
      <DigesterHeader />
      <DigesterMetricsTable
        config={{
          liveMetrics: [
            {
              label: (
                <span className="font-semibold text-muted-foreground">
                  Current Day Feeding Total <i>(Gal)</i>
                </span>
              ),
              type: "Total",
              total: "Sum",
            },
            {
              label: (
                <span className="font-semibold text-muted-foreground">
                  Upper Temperature <i>(F)</i>
                </span>
              ),
              type: "Rate",
              total: "Average",
            },
            {
              label: (
                <span className="font-semibold text-muted-foreground">
                  Lower Temperature <i>(F)</i>
                </span>
              ),
              type: "Rate",
              total: "Average",
            },
            {
              label: (
                <span className="font-semibold text-muted-foreground">
                  Pressure <i>(in H2O)</i>
                </span>
              ),
              type: "Rate",
              total: "Average",
            },
            {
              label: (
                <span className="font-semibold text-muted-foreground">
                  Gas Flow <i>(SCFM)</i>
                </span>
              ),
              type: "Rate",
              total: "Sum",
            },
          ],
          colorRanges: [
            [
              {
                lower: 0,
                upper: 65000,
                color: "text-status-bad",
              },
              {
                lower: 65000,
                upper: 75000,
                color: "text-status-good",
              },
              {
                lower: 75000,
                upper: 85000,
                color: "text-status-warn",
              },
              {
                lower: 85000,
                upper: 1000000,
                color: "text-status-bad",
              },
            ],
            [
              {
                lower: 0,
                upper: 98,
                color: "text-status-bad",
              },
              {
                lower: 98,
                upper: 101,
                color: "text-foreground",
              },
              {
                lower: 101,
                upper: 104,
                color: "text-status-good",
              },
              {
                lower: 104,
                upper: 1000,
                color: "text-status-bad",
              },
            ],
            [
              {
                lower: 0,
                upper: 98,
                color: "text-status-bad",
              },
              {
                lower: 98,
                upper: 101,
                color: "text-foreground",
              },
              {
                lower: 101,
                upper: 104,
                color: "text-status-good",
              },
              {
                lower: 104,
                upper: 1000,
                color: "text-status-bad",
              },
            ],
            [
              {
                lower: 0,
                upper: 3.5,
                color: "text-foreground",
              },
              {
                lower: 3.5,
                upper: 100,
                color: "text-status-bad",
              },
            ],
            [
              {
                lower: 0,
                upper: 120,
                color: "text-status-bad",
              },
              {
                lower: 120,
                upper: 1000,
                color: "text-status-good",
              },
            ],
          ],
          groups: [
            {
              name: "Pod 1",
              digesters: [
                {
                  key: 501,
                  tagPaths: [
                    "default/BCO/Live/500/501/Daily_Feed_Total",
                    "default/BCO/Live/500/501/Upper_Temp",
                    "default/BCO/Live/500/501/Lower_Temp",
                    "default/BCO/Live/500/501/Pressure",
                    "",
                  ],
                },
                {
                  key: 502,
                  tagPaths: [
                    "default/BCO/Live/500/502/Daily_Feed_Total",
                    "default/BCO/Live/500/502/Upper_Temp",
                    "default/BCO/Live/500/502/Lower_Temp",
                    "default/BCO/Live/500/502/Pressure",
                    "default/BCO/Live/500/502/Gas_Flow",
                  ],
                },
                {
                  key: 503,
                  tagPaths: [
                    "default/BCO/Live/500/503/Daily_Feed_Total",
                    "default/BCO/Live/500/503/Upper_Temp",
                    "default/BCO/Live/500/503/Lower_Temp",
                    "default/BCO/Live/500/503/Pressure",
                    "default/BCO/Live/500/503/Gas_Flow",
                  ],
                },
                {
                  key: 504,
                  tagPaths: [
                    "default/BCO/Live/500/504/Daily_Feed_Total",
                    "default/BCO/Live/500/504/Upper_Temp",
                    "default/BCO/Live/500/504/Lower_Temp",
                    "default/BCO/Live/500/504/Pressure",
                    "default/BCO/Live/500/504/Gas_Flow",
                  ],
                },
              ],
            },
            {
              name: "Pod 2",
              digesters: [
                {
                  key: 505,
                  tagPaths: [
                    "default/BCO/Live/500/505/Daily_Feed_Total",
                    "default/BCO/Live/500/505/Upper_Temp",
                    "default/BCO/Live/500/505/Lower_Temp",
                    "default/BCO/Live/500/505/Pressure",
                    "default/BCO/Live/500/505/Gas_Flow",
                  ],
                },
                {
                  key: 506,
                  tagPaths: [
                    "default/BCO/Live/500/506/Daily_Feed_Total",
                    "default/BCO/Live/500/506/Upper_Temp",
                    "default/BCO/Live/500/506/Lower_Temp",
                    "default/BCO/Live/500/506/Pressure",
                    "default/BCO/Live/500/506/Gas_Flow",
                  ],
                },
                {
                  key: 507,
                  tagPaths: [
                    "default/BCO/Live/500/507/Daily_Feed_Total",
                    "default/BCO/Live/500/507/Upper_Temp",
                    "default/BCO/Live/500/507/Lower_Temp",
                    "default/BCO/Live/500/507/Pressure",
                    "default/BCO/Live/500/507/Gas_Flow",
                  ],
                },
                {
                  key: 508,
                  tagPaths: [
                    "default/BCO/Live/500/508/Daily_Feed_Total",
                    "default/BCO/Live/500/508/Upper_Temp",
                    "default/BCO/Live/500/508/Lower_Temp",
                    "default/BCO/Live/500/508/Pressure",
                    "default/BCO/Live/500/508/Gas_Flow",
                  ],
                },
              ],
            },
            {
              name: "Pod 3",
              digesters: [
                {
                  key: 509,
                  tagPaths: [
                    "default/BCO/Live/500/509/Daily_Feed_Total",
                    "default/BCO/Live/500/509/Upper_Temp",
                    "default/BCO/Live/500/509/Lower_Temp",
                    "default/BCO/Live/500/509/Pressure",
                    "default/BCO/Live/500/509/Gas_Flow",
                  ],
                },
                {
                  key: 510,
                  tagPaths: [
                    "default/BCO/Live/500/510/Daily_Feed_Total",
                    "default/BCO/Live/500/510/Upper_Temp",
                    "default/BCO/Live/500/510/Lower_Temp",
                    "default/BCO/Live/500/510/Pressure",
                    "default/BCO/Live/500/510/Gas_Flow",
                  ],
                },
                {
                  key: 511,
                  tagPaths: [
                    "default/BCO/Live/500/511/Daily_Feed_Total",
                    "default/BCO/Live/500/511/Upper_Temp",
                    "default/BCO/Live/500/511/Lower_Temp",
                    "default/BCO/Live/500/511/Pressure",
                    "default/BCO/Live/500/511/Gas_Flow",
                  ],
                },
                {
                  key: 512,
                  tagPaths: [
                    "default/BCO/Live/500/512/Daily_Feed_Total",
                    "default/BCO/Live/500/512/Upper_Temp",
                    "default/BCO/Live/500/512/Lower_Temp",
                    "default/BCO/Live/500/512/Pressure",
                    "default/BCO/Live/500/512/Gas_Flow",
                  ],
                },
              ],
            },
            {
              name: "Pod 4",
              digesters: [
                {
                  key: 513,
                  tagPaths: [
                    "default/BCO/Live/500/513/Daily_Feed_Total",
                    "default/BCO/Live/500/513/Upper_Temp",
                    "default/BCO/Live/500/513/Lower_Temp",
                    "default/BCO/Live/500/513/Pressure",
                    "default/BCO/Live/500/513/Gas_Flow",
                  ],
                },
                {
                  key: 514,
                  tagPaths: [
                    "default/BCO/Live/500/514/Daily_Feed_Total",
                    "default/BCO/Live/500/514/Upper_Temp",
                    "default/BCO/Live/500/514/Lower_Temp",
                    "default/BCO/Live/500/514/Pressure",
                    "default/BCO/Live/500/514/Gas_Flow",
                  ],
                },
                {
                  key: 515,
                  tagPaths: [
                    "default/BCO/Live/500/515/Daily_Feed_Total",
                    "default/BCO/Live/500/515/Upper_Temp",
                    "default/BCO/Live/500/515/Lower_Temp",
                    "default/BCO/Live/500/515/Pressure",
                    "default/BCO/Live/500/515/Gas_Flow",
                  ],
                },
                {
                  key: 516,
                  tagPaths: [
                    "default/BCO/Live/500/516/Daily_Feed_Total",
                    "default/BCO/Live/500/516/Upper_Temp",
                    "default/BCO/Live/500/516/Lower_Temp",
                    "default/BCO/Live/500/516/Pressure",
                    "default/BCO/Live/500/516/Gas_Flow",
                  ],
                },
              ],
            },
          ],
          kpis: [
            {
              $type: "basic",
              location: 2,
              typeId: 1,
              aggFunction: "Average",
              dimension: "digester",
              id: 45,
            },
            {
              $type: "basic",
              location: 2,
              typeId: 1,
              aggFunction: "Average",
              dimension: "digester",
              id: 47,
            },
            {
              $type: "basic",
              location: 2,
              typeId: 1,
              aggFunction: "Average",
              dimension: "digester",
              id: 48,
            },
            {
              $type: "basic",
              location: 2,
              typeId: 1,
              aggFunction: "Max",
              dimension: "digester",
              id: 41,
            },
            {
              $type: "basic",
              location: 2,
              typeId: 1,
              aggFunction: "Average",
              dimension: "digester",
              id: 40,
            },
          ],
          kpiTotals: ["Sum", "Average", "Average", "Sum"],
        }}
      />
    </>
  )
}
